module.exports = __webpack_public_path__ + "img/ai_00.2fd4ca0b.png";